module.exports = __webpack_public_path__ + "static/media/sushmita.22d3f8bb.png";